export type NotificationType =
  | 'FirmCreated'
  | 'FirmDeleted'
  | 'FirmUserInviteCreated'
  | 'LegalMatterCreated'
  | 'LegalMatterAccepted'
  | 'LegalMatterAssigned'
  | 'LegalMatterAssignedToFirm'
  | 'LegalMatterClaimed'
  | 'LegalMatterRejected'
  | 'LegalMatterClosed'
  | 'LegalMatterCancelled'
  | 'LegalMatterWithdrawn'
  | 'LegalMatterShared'
  | 'LegalMatterShareRejected'
  | 'LegalMatterReferredIn'
  | 'LegalMatterReferredOut'
  | 'LegalMatterPreviewEnter'
  | 'LegalMatterCleanExpiredPreviews'
  | 'LegalMatterReferralAccepted'
  | 'LegalMatterReferralRejected'
  | 'CalendarEventCreated'
  | 'CalendarEventUpdated'
  | 'CalendarEventDeleted'
  | 'TaskCreated'
  | 'TaskCompleted'
  | 'LegalMatterDocumentDeleted'
  | 'LegalMatterDocumentUpdated'
  | 'UserClaimsUpdated'
  | 'SubscriptionUpdated'
  | 'SubscriptionDeleted'
  | 'QuoteSent'
  | 'QuoteRejected'
  | 'QuoteAccepted'
  | 'QuoteDeleted'
  | 'QuoteUpdated'

export const legalMatterEvents = [
  'LegalMatterCreated',
  'LegalMatterAccepted',
  'LegalMatterAssigned',
  'LegalMatterAssignedToFirm',
  'LegalMatterClaimed',
  'LegalMatterRejected',
  'LegalMatterClosed',
  'LegalMatterCancelled',
  'LegalMatterWithdrawn',
  'LegalMatterShared',
  'LegalMatterShareRejected',
  'LegalMatterReferredIn',
  'LegalMatterReferredOut',
  'LegalMatterPreviewEnter',
  'LegalMatterCleanExpiredPreviews',
  'LegalMatterReferralAccepted',
  'LegalMatterReferralRejected',
]
export const taskEvents = ['TaskCreated', 'TaskCompleted']
export const calendarEvents = [
  'CalendarEventCreated',
  'CalendarEventUpdated',
  'CalendarEventDeleted',
]
export const documentEvents = [
  'LegalMatterDocumentUpdated',
  'LegalMatterDocumentDeleted',
]
export const QuoteEvents = [
  'QuoteSent',
  'QuoteRejected',
  'QuoteAccepted',
  'QuoteDeleted',
  'QuoteUpdated',
]

interface NotificationInfo {
  description?: string
  subscriber_message: string
  attorney_message: string
}

export const NotificationMessages: Partial<
  Record<NotificationType, NotificationInfo>
> = {
  LegalMatterCreated: {
    subscriber_message: 'Your new legal matter has been created.',
    attorney_message: 'A new legal matter has been created.',
  },
  LegalMatterAccepted: {
    subscriber_message: 'A lawyer has accepted to take up your legal matter.',
    attorney_message: 'A lawyer has accepted to take up the legal matter.',
  },
  LegalMatterAssigned: {
    subscriber_message: '',
    attorney_message: 'A legal matter has been assigned to you.',
  },
  LegalMatterAssignedToFirm: {
    subscriber_message:
      'A legal matter has been referred to a Firm in our network.',
    attorney_message:
      'A legal matter has been referred to a Firm in our network.',
  },
  LegalMatterClaimed: {
    subscriber_message: 'Your legal matter has been assigned to a lawyer.',
    attorney_message: 'Legal matter has been claimed by a lawyer.',
  },
  LegalMatterRejected: {
    subscriber_message: '',
    attorney_message:
      'A lawyer has rejected a legal matter, please review and assign a new one.',
  },
  LegalMatterClosed: {
    subscriber_message:
      'A legal matter has been closed by the assigned lawyer.',
    attorney_message: 'A legal matter has been closed by the assigned lawyer.',
  },
  LegalMatterCancelled: {
    subscriber_message: 'You have successfully canceled this legal matter.',
    attorney_message: 'Legal matter has been canceled by the insured.',
  },
  LegalMatterWithdrawn: {
    subscriber_message: '',
    attorney_message:
      'The lawyer has withdrawn from a legal matter, please assign a new one.',
  },
  LegalMatterShared: {
    subscriber_message: '',
    attorney_message: 'An attorney has shared a legal matter with you',
  },
  LegalMatterShareRejected: {
    subscriber_message: '',
    attorney_message:
      'A law firm colleague has removed themselves from the legal matter.',
  },
  LegalMatterReferredIn: {
    subscriber_message:
      "A legal matter has been referred in to our attorney's Network",
    attorney_message:
      'A Legal matter has been referred in to the firms network',
  },
  LegalMatterReferredOut: {
    subscriber_message: '',
    attorney_message: 'The legal matter has successfully been referred out.',
  },
  LegalMatterPreviewEnter: {
    subscriber_message:
      'A firm is currently previewing your legal matter for acceptance.',
    attorney_message:
      'Another firm has taken this legal matter into preview mode.',
  },
  LegalMatterCleanExpiredPreviews: {
    subscriber_message: '',
    attorney_message:
      'A legal matter you had on preview mode has expired its time limit.',
  },
  LegalMatterReferralAccepted: {
    subscriber_message:
      'Your legal matter has been accepted by a Firm and will assign an attorney for you.',
    attorney_message: 'Legal matter referred has been accepted successfully.',
  },
  LegalMatterReferralRejected: {
    subscriber_message:
      'The firm has rejected your legal matter and it is going back to our attorney network for a new firm to review.',
    attorney_message: 'Legal matter referred has been rejected successfully.',
  },
  CalendarEventCreated: {
    subscriber_message: 'A new calendar event has been created.',
    attorney_message: 'A new calendar event has been created.',
  },

  CalendarEventUpdated: {
    subscriber_message: 'A calendar event has been updated.',
    attorney_message: 'A calendar event has been updated.',
  },

  CalendarEventDeleted: {
    subscriber_message: 'A calendar event has been deleted.',
    attorney_message: 'A calendar event has been deleted.',
  },

  TaskCreated: {
    subscriber_message: 'A new task has been created.',
    attorney_message: 'A new task has been created.',
  },

  TaskCompleted: {
    subscriber_message: 'A task has been marked completed.',
    attorney_message: 'A task has been marked completed.',
  },
  LegalMatterDocumentDeleted: {
    subscriber_message: '',
    attorney_message: 'A document has been deleted from this matter.',
  },
  LegalMatterDocumentUpdated: {
    subscriber_message: 'A document has been attached to the legal matter.',
    attorney_message: 'A document has been attached to this legal matter.',
  },
  SubscriptionDeleted: {
    subscriber_message: "The insured's policy is no longer in effect.",
    attorney_message: "The insured's policy is no longer in effect.",
  },
  QuoteSent: {
    subscriber_message:
      'An attorney has sent a Quote on your legal matter for review.',
    attorney_message: '',
  },
  QuoteRejected: {
    subscriber_message: '',
    attorney_message: 'A member has rejected a quote on a legal matter.',
  },
  QuoteAccepted: {
    subscriber_message: '',
    attorney_message: 'A member has accepted a quote on a legal matter.',
  },
  QuoteDeleted: {
    subscriber_message: 'An attorney as deleted a quote on a legal matter.',
    attorney_message: '',
  },
  QuoteUpdated: {
    subscriber_message: 'A quote has been updated on a legal matter.',
    attorney_message: '',
  },
}
